import { createQuery, type Query, type Store } from '@datorama/akita';
import { v4 as uuidv4 } from 'uuid';

import applicationContextStore, { type ApplicationContextState } from 'context/ApplicationContext/store';
import { type ErrorObject } from 'types/models';
import axiosClient from 'utils/axiosAPIClient';

export default class ApplicationService {
   static apiVersion = 'v2';
   protected httpClient!: typeof axiosClient;

   private version!: string;
   private static instance: ApplicationService;
   private store!: Store<ApplicationContextState>;
   private query!: Query<ApplicationContextState>;

   constructor() {
      if (!ApplicationService.instance) {
         this.store = applicationContextStore;
         this.query = createQuery(this.store);
         this.version = ApplicationService.apiVersion;
         this.httpClient = axiosClient;

         ApplicationService.instance = this;
      }

      // Service shall be instantiated only once, otherwise the observable will be created for each service instance
      return ApplicationService.instance;
   }

   setProperty(propertyName: string, value: any): void {
      this.store.update({ [propertyName]: value });
   }

   getProperty(propertyName: keyof ApplicationContextState): any {
      return this.query.getValue()?.[propertyName];
   }

   setLoading(loading: boolean): void {
      this.store.setLoading(loading);
   }

   setError(error: ErrorObject): void {
      this.store.setError({
         code: error?.response?.status ?? error?.response?.data?.code,
         variant: 'error',
         message: `${error?.response?.data?.message ?? error.message ?? ''} ${error?.response?.data?.error ?? ''}`,
         key: `${this.store?.storeName}#${uuidv4()}`,
         store: this.store?.storeName,
      });
      this.store.setLoading(false);
   }

   async updateCache() {
      return this.httpClient.post(`/${this.version}/updatecache`).catch((error) => this.setError(error));
   }
}
